<template>
  <NuxtLayout
    :is-menu-hidden="page?.is_menu_hidden"
    :is-footer-hidden="page?.is_footer_hidden"
    should-add-margin-top-into-main-content
  >
    <div>
      <Widgets v-if="page?.widgets" :widgets="page?.widgets" />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const { data: page } = await useAsyncData('page', () =>
  useApi().publicPagesSimplePagesRetrieve('home')
)

const { meta } = usePrepareSEOHead(page)
useHead({
  title: page?.value?.title,
  meta
})
</script>
